import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import SwiperCore, { Autoplay, EffectFade, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { prepareNewWindowUrl } from '../../../utilities/StringHelpers/StringHelpers';
import 'swiper/swiper.scss';
import Config from '../../../Config';
import DevicesServiceBoxPopUp from './DevicesServiceBoxPopUp';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import PopUp from '../../Shared/Popup/PopUp';
import { setIsWorkOrderSucceeded } from '../WelcomeBlock/welcomeBlockSlice';
import { WorkOrderStatus } from './WorkOrderEnum';
import { createReportDevicesAndEquipments } from '../../../utilities/reports/createReport';

SwiperCore.use([Autoplay, Navigation, EffectFade]);

const getTypeOfCustomer = (isOrganization, isPrivateData) => {
  if (isOrganization) {
    return 'Organization';
  } else if (!isOrganization && !isPrivateData) return 'none';
  return 'Private';
};

const MainDevicesAndEquipments = (props) => {
  const [swiperInstence, setSwiperInstence] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showPopUp, setShowPopUp] = useState(false);
  const [itemInfo, setItemInfo] = useState({});

  const isOrganization = props.organizationData?.organizationCodeList?.value?.length > 0 ? true : false;
  const isPrivateData = props.iContent?.devicesAndEquipments?.expandedValue?.length > 0 ? true : false;
  const showDevices = getTypeOfCustomer(isOrganization, isPrivateData);
  const devicesAndEquipmentsObj = {
    linkDetailsString: '',
    title: '',
    buttonOffersLink: '',
    buttonOffersLinkTitle: '',
    jobCode: '',
    jobTeam: '',
    items: [],
  };

  function closePopUp() {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    setShowPopUp(false);
  }

  if (showDevices === 'Organization') {
    devicesAndEquipmentsObj.linkDetailsString = 'מידע נוסף';
    devicesAndEquipmentsObj.title = props.organizationData?.title?.value;
    devicesAndEquipmentsObj.jobCode = props.organizationData?.jobCodeGeneralProducts?.value;
    devicesAndEquipmentsObj.jobTeam = props.organizationData?.teamCodeGeneralProducts?.value;
    devicesAndEquipmentsObj.items = props.organizationData?.devicesAndEquipments?.expandedValue;
    devicesAndEquipmentsObj.buttonOffersLink = props.organizationData.buttonOffersLink?.value;
    devicesAndEquipmentsObj.buttonOffersLinkTitle = props.organizationData.buttonOffersLinkTitle?.value;

  }
  if (showDevices === 'Private') {
    devicesAndEquipmentsObj.linkDetailsString = 'מידע נוסף';
    devicesAndEquipmentsObj.title = props.iContent.title?.value;
    devicesAndEquipmentsObj.jobCode = props.iContent.jobCode?.value;
    devicesAndEquipmentsObj.jobTeam = props.iContent.jobTeam?.value;
    devicesAndEquipmentsObj.items = props.iContent.devicesAndEquipments?.expandedValue;
    devicesAndEquipmentsObj.buttonOffersLink = props.iContent.buttonOffersLink?.value;
    devicesAndEquipmentsObj.buttonOffersLinkTitle = props.iContent.buttonOffersLinkTitle?.value;
  }

  if (devicesAndEquipmentsObj?.items?.length > 0) {
    return (
      <div className='device-and-equipments-block'>
        <div className='container'>
          <div className='titleContainer'>
            <span className='title'>{devicesAndEquipmentsObj?.title}</span>
          </div>

          <Swiper
            navigation={isMobile || devicesAndEquipmentsObj?.items.length < 5 ? false : true}
            slidesPerView={isMobile ? 2 : 4}
            onSwiper={(swiper) => {
              setSwiperInstence(swiper);
            }}
            effect='slide'
            onSlideChange={(swiper) => {
              setActiveIndex(swiper?.activeIndex);
            }}>
            {devicesAndEquipmentsObj?.items?.map((item, i) => (
              <SwiperSlide key={i} className='slideDesign'>
                <div className='borderImageDesktop'>
                  {!isMobile && (
                    <Image src={Config.epiBaseUrl + item.image.expandedValue.url} className='imageContainer' />
                  )}
                  {isMobile && (
                    <Image src={Config.epiBaseUrl + item.mobileImage.expandedValue.url} className='imageContainer' />
                  )}

                </div>
                <div className='infoData'>

                  <div className='description'>
                    <span>{item.description?.value}</span>
                  </div>


                  {item.linkDetails.value == null && (
                    <div className='linkDetails'>
                      <span style={{ cursor: 'auto' }}></span>
                    </div>
                  )}

                  {item.linkDetails.value != null && (
                    <div className='linkDetails'>
                      <a onClick={() => { prepareNewWindowUrl(item.linkDetails.value, props.context), createReportDevicesAndEquipments('Info Link Clicked', item.description?.value) }}>
                        {devicesAndEquipmentsObj.linkDetailsString}
                      </a>
                      <div className='leftArrowDetails'></div>
                    </div>
                  )}


                </div>
                <div className='prices'>
                  {item.priceDeleted?.value != '' && (
                    <div>
                      <span className='prices-deleted-price'>&#8362;</span>
                      <span className='prices-deleted-price'>{item.priceDeleted.value}</span>
                      <span>&emsp;</span>
                      <span>&#8362;</span>
                      <span className='prices-price'>{item.price.value}</span>
                    </div>
                  )}
                  {item.priceDeleted?.value == '' && (
                    <div>
                      <span>&#8362;</span>
                      <span className='prices-price'>{item.price.value}</span>
                    </div>
                  )}

                </div>

                <div
                  className='btn-purchase'
                  onClick={() => {
                    setShowPopUp(true), setItemInfo(item), props.setIsWorkOrderSucceeded(WorkOrderStatus.START), createReportDevicesAndEquipments('Device Order Button Clicked', item.description?.value);
                  }}>
                  {item.buttonPurchaseLinkTitle.value}
                </div>



              </SwiperSlide>
            ))}
          </Swiper>
          {devicesAndEquipmentsObj?.buttonOffersLinkTitle !== '' && devicesAndEquipmentsObj?.buttonOffersLink != null && (
            <a className='offers' onClick={() => prepareNewWindowUrl(devicesAndEquipmentsObj?.buttonOffersLink, props.context)}>
              {devicesAndEquipmentsObj?.buttonOffersLinkTitle}
            </a>
          )}
          {showPopUp && (
            <PopUp showPopUp={showPopUp} onClose={() => closePopUp()}>
              <DevicesServiceBoxPopUp
                isPopUp={true}
                showPopup={setShowPopUp}
                workOrderCodeInput={devicesAndEquipmentsObj.jobCode}
                workOrderTeamInput={devicesAndEquipmentsObj.jobTeam}
                productPriceInput={itemInfo.price.value}
                productInfoInput={itemInfo.description.value}
                footerButton={<BtnSubmit onclick={() => setShowPopUp(false)} text='סגור' />}
              />
            </PopUp>
          )}
        </div>
      </div>
    );
  }
  else {
    return (
      <div></div>
    )
  }

};

const mapStateToProps = (state) => {
  return {
    organizationData: state.welcomeBlock?.organizationState,
    devices: state.welcomeBlock.welcomeState.workOrderState,
  };
};

const mapDispatchToProps = {
  setIsWorkOrderSucceeded,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainDevicesAndEquipments);
